module.exports = __webpack_public_path__ + "static/5-31a962312fa599b2ec3cb34222a2b15c.jpg";